<template>
  <ts-table
    :table-data="tableData"
    :table-head="columns"
    :table-title-obj="tableTitleObj"
    @size-change="handleSizeChange"
    @on-handle-filter="handleFilter"
    @current-change="handleCurrentChange"
    @on-handle-table-first="handleTableFirst"
  />
</template>

<script>
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import TsTable from '@/components/TsTable/TsTable.vue'
import { getActivationUserPage } from '@/api/manage/userManage'

@Component({
  name: 'PermissionMsg',
  components: {
    TsTable
  }
})
export default class extends Vue {
  @Prop({ default: Object }) dataObj
  @Prop({ default: String }) tabName
  @Prop({ default: Boolean }) isOpen
  @Watch('isOpen')
  handleIsOpenChange (newV) {
    if (newV) {
      this.handleSearch(this.tableData.currentPage, this.tableData.pageSize)
    }
  }

  @Watch('tabName')
  handleTabChange (newV) {
    if (newV && newV === 'two') {
      this.handleSearch(this.tableData.currentPage, this.tableData.pageSize)
    }
  }

  searchParams = {}
  tableData = {
    data: [],
    currentPage: 0,
    pageSize: 20,
    total: 0
  }

  tableTitleObj = {
    title: '许可证信息',
    options: {
      dropdown: false,
      arr: [
      ]
    }
  }

  columns = [
    {
      labelName: '许可证名称',
      type: 'first',
      propName: 'activationKey',
      options: {
        type: 'search'
      }
    },
    {
      labelName: '激活时间',
      propName: 'registerDate',
      options: {
        type: 'sort',
        optionArr: [
          {
            type: 'asc',
            name: '升序',
            icon: 'el-icon-top'
          },
          {
            type: 'desc',
            name: '降序',
            icon: 'el-icon-bottom'
          }
        ]
      }
    },
    {
      labelName: '剩余日期(天)',
      propName: 'remainDays',
      options: {
        type: 'sort',
        optionArr: [
          {
            type: 'asc',
            name: '升序',
            icon: 'el-icon-top'
          },
          {
            type: 'desc',
            name: '降序',
            icon: 'el-icon-bottom'
          }
        ]
      }
    },
    {
      labelName: '使用费(元)',
      propName: 'royalty'
    },
    {
      labelName: '咨询费(元)',
      propName: 'consultingFees'
    },
    {
      labelName: '交易日期',
      propName: 'createTime',
      options: {
        type: 'sort',
        optionArr: [
          {
            type: 'asc',
            name: '升序',
            icon: 'el-icon-top'
          },
          {
            type: 'desc',
            name: '降序',
            icon: 'el-icon-bottom'
          }
        ]
      }
    }
  ]

  mounted () {
    this.handleSearch(this.tableData.currentPage, this.tableData.pageSize)
  }

  handleSizeChange (size) {
    this.tableData.pageSize = size
    this.tableData.currentPage = 0
    this.handleSearch(0, size)
  }

  handleCurrentChange (current) {
    this.tableData.currentPage = current
    this.handleSearch(current, this.tableData.pageSize)
  }

  handleTableFirst (row) {
    this.$router.push(`/manage/userLicense?id=${row.id}`)
  }

  handleFilter (tags) {
    if (tags.length) {
      this.searchParams = {}
      tags.forEach((item) => {
        const key = item.type
        if (item.params.opt.type) {
          this.searchParams.sortField = key
          this.searchParams.direction = item.params.opt.type
        } else {
          this.searchParams[key] = item.params.opt.value || item.params.opt.type
        }
      })
    } else {
      this.searchParams = {}
    }
    console.log('过滤结果：', tags)
    this.handleSearch(0, this.tableData.pageSize)
  }

  handleSearch (page = 0, size = 20) {
    const params = Object.assign({}, this.searchParams, {
      userId: this.dataObj.searchFormData.id,
      size,
      page
    })
    getActivationUserPage(params).then(res => {
      if (res.statusCode === 0 && res.success) {
        this.tableData.data = res.data.content || []
        // if (this.tableData.data.length) {
        //   this.tableData.data = this.tableData.data.map((item) => {
        //     item = Object.assign({}, item, {
        //       createTime: item.createTime ? item.createTime.slice(0, 10) : ''
        //     })
        //     return item
        //   })
        // }
        this.tableData.total = res.data.totalElements
      }
    })
  }
}
</script>

<style scoped>

</style>
